<div class="billing-header">
  <h1>Billing</h1>
  @if (nativeTeamContextReady && isNativeTeamContextActive) {
    <section
      class="native-team-context"
      aria-label="Billing Team context"
      >
      <div class="native-team-summary">
        <span class="native-team-label">Team</span>
        <strong>{{selectedNativeTeam?.name || 'No Team selected'}}</strong>
      </div>
      @if (nativeTeams.length > 1) {
        <mat-form-field appearance="outline">
          <mat-label>Team</mat-label>
          <mat-select [value]="selectedTeamId" (selectionChange)="onNativeTeamChange($event.value)">
            @for (team of nativeTeams; track team) {
              <mat-option [value]="team.id">{{team.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (nativeTeams.length === 0) {
        <span class="native-team-empty">
          No Teams are available for this company.
        </span>
      }
    </section>
  }
</div>
@if (badgeCount > 0) {
  <span class="achinfo"
    >You have {{ badgeCount }} pending ACH transfer{{ badgeCount === 1 ? '' : 's' }}</span
    >
  }
  @if (currentWellspaceId && !balanceLoading && !balanceLoadError) {
    @if (balance < 0) {
      <div>
        <span class="balance">Credit toward future invoices: {{ -balance | currency }}</span>
        <p class="balance-explanation">This credit will reduce future invoices as they are finalized. It does not reflect unpaid invoices.</p>
      </div>
    }
    @if (balance > 0) {
      <div>
        <span class="balance">Adjustment added to the next invoice: {{ balance | currency }}</span>
        <p class="balance-explanation">This amount will be added when the next invoice is finalized. It does not reflect unpaid invoices.</p>
      </div>
    }
  }
  @if (currentWellspaceId && balanceLoading) {
    <span class="balance-state">Loading Team balance…</span>
  }
  @if (balanceLoadError) {
    <span class="balance-state balance-error">{{balanceLoadError}}</span>
  }
  <nav mat-tab-nav-bar [tabPanel]="tabs">
    @for (link of links; track link) {
      <a
        mat-tab-link
        [routerLink]="link.link"
        (click)="activeLink = link"
        [active]="activeLink == link"
        >{{ link.title }}</a
        >
      }
    </nav>
    @if (activeLink?.title === 'Payment Methods') {
      <app-stripepaymentmethods></app-stripepaymentmethods>
    }
    @if (activeLink?.title === 'Add Available Payment Method') {
      <app-stripe-available-payment-methods
      ></app-stripe-available-payment-methods>
    }
    @if (activeLink?.title === 'Add Payment Method') {
      <app-stripecreditcard></app-stripecreditcard>
    }
    @if (activeLink?.title === 'Charge History') {
      <app-stripe-chargehistory></app-stripe-chargehistory>
    }
    <mat-tab-nav-panel #tabs></mat-tab-nav-panel>
